import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-agents-list',
  templateUrl: './agents-list.component.html',
  styleUrls: ['./agents-list.component.css']
})
export class AgentsListComponent implements OnInit {

  @Input() userAgentList: any;

  newSaleSumm: number = 0;

  salesVolumeSumm: number = 0;

  activeAgentsSumm: number = 0;

  constructor() { }

  ngOnInit() {
  }


  ngOnChanges(){
    if(this.userAgentList.ag_tree != undefined){
      let newSale = 0;
      let salesVolume = 0;
      let activeAgents = 0;
      for(let summ of this.userAgentList.ag_tree){
        if(summ.new_business_count != undefined){
          this.newSaleSumm = this.newSaleSumm + summ.new_business_count;
        }
        this.salesVolumeSumm = this.salesVolumeSumm + summ.volume;
        if(summ.active_agent == 1){
          this.activeAgentsSumm = this.activeAgentsSumm + 1;
        }
      }
      
    }
  }



}
